import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect  } from "react";
import { getOrganization } from "../../slices/organization";

// Dedupe in-flight / completed lookups across many table cells
const requestedOrgIds = new Set();

const NiceOrganization = (props) => {

  const dispatch = useDispatch();
  
  const organization = useSelector((state) => state.organizations.data.list?.find(org => org.id === props.children));

  useEffect(() => {
    const id = props.children;
    if (!id || organization || requestedOrgIds.has(id)) {
      return;
    }
    requestedOrgIds.add(id);
    dispatch(getOrganization({ id }));
  }, [organization, props.children, dispatch]);

return (
  <>
  {organization &&
  <Box display="flex" justifyContent="start" alignItems="baseline"> 
    {`${organization.name}`}
  </Box>
}
</>)
}

export default React.memo(NiceOrganization);
